var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useRetrieveUserIntraSquadMatchPermissions } from "../api/PermissionApiProvider";
import { useRetrieveIntraSquadMatch, useRetrievePlayersByTeamId, useRetrieveTeam, useRetrieveTeamPreferences, useSubmitIntraSquadMatchStats, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { IntraSquadMatchStatsForm, } from "./IntraSquadMatchStatsForm";
export var UpdatePlayerIntraSquadMatchStats = function () {
    var id = useNumericParams().id;
    var _a = useRetrieveUserIntraSquadMatchPermissions({ intraSquadMatchId: id }), userIntraSquadMatchPermissions = _a.data, userIntraSquadMatchPermissionsIsLoading = _a.isLoading, userIntraSquadMatchPermissionsError = _a.error;
    var _b = (userIntraSquadMatchPermissions || {}).canModify, canModify = _b === void 0 ? false : _b;
    var _c = useRetrieveIntraSquadMatch({ id: id, enabled: canModify }), useRetrieveIntraSquadMatchIsLoading = _c.isLoading, useRetrieveIntraSquadMatchError = _c.error, intraSquadMatch = _c.data;
    var _d = useRetrieveTeam({ id: intraSquadMatch === null || intraSquadMatch === void 0 ? void 0 : intraSquadMatch.team }), isTeamLoading = _d.isLoading, teamError = _d.error, team = _d.data;
    var _e = useRetrievePlayersByTeamId({ teamId: intraSquadMatch === null || intraSquadMatch === void 0 ? void 0 : intraSquadMatch.team }), players = _e.data, playersError = _e.error, playersIsLoading = _e.isLoading;
    var _f = useRetrieveTeamPreferences({ teamId: intraSquadMatch === null || intraSquadMatch === void 0 ? void 0 : intraSquadMatch.team }), teamPreferences = _f.data, teamPreferencesError = _f.error, teamPreferencesIsLoading = _f.isLoading;
    var navigate = useNavigate();
    var _g = useSubmitIntraSquadMatchStats(intraSquadMatch), submitStatsIsLoading = _g.isLoading, submitStatsIsError = _g.isError, submitStatsMutateAsync = _g.mutateAsync;
    if (userIntraSquadMatchPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (userIntraSquadMatchPermissionsError) {
        return _jsx(ErrorView, { error: userIntraSquadMatchPermissionsError });
    }
    if (teamError) {
        return _jsx(ErrorView, { error: teamError });
    }
    if (!canModify) {
        return _jsx(NotFound, {});
    }
    if (teamPreferencesIsLoading ||
        submitStatsIsLoading ||
        playersIsLoading ||
        useRetrieveIntraSquadMatchIsLoading ||
        isTeamLoading ||
        !intraSquadMatch) {
        return _jsx(Loading, {});
    }
    var onSubmit = function (intraSquadMatchResult, playerIntraSquadMatchStats) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, submitStatsMutateAsync({
                        result: __assign(__assign({}, (intraSquadMatchResult.id ? { id: intraSquadMatchResult.id } : {})), { teamAScore: intraSquadMatchResult.teamAScore, teamBScore: intraSquadMatchResult.teamBScore }),
                        playerStats: playerIntraSquadMatchStats,
                    })];
                case 1:
                    _a.sent();
                    navigate("/teams/".concat(intraSquadMatch.team, "/intra-squad-matches/").concat(id, "/"));
                    return [2 /*return*/];
            }
        });
    }); };
    if (!teamPreferences ||
        useRetrieveIntraSquadMatchError ||
        playersError ||
        players === undefined ||
        teamPreferencesError) {
        return (_jsx(ErrorView, { error: useRetrieveIntraSquadMatchError || playersError }));
    }
    if (!team) {
        return _jsx(ErrorView, { error: new Error("Could not load team!") });
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: submitStatsIsError, message: "Failed to save intra-squad match stats! Please try again." }), _jsx(Typography, { variant: "h6", children: _jsxs("strong", { children: ["Intra-Squad Match Stats for ", team.name] }) }), _jsx(Typography, { variant: "subtitle2", children: format(new Date(intraSquadMatch.kickOff), "MMMM do yyyy @ H:mma") }), _jsx(IntraSquadMatchStatsForm, { players: players, onSubmit: onSubmit, intraSquadMatch: intraSquadMatch, teamPreferences: teamPreferences })] }));
};
